import SurveySubmittedPageContainer from "./Containers/SurveySubmittedPageContainer";
export default SurveySubmittedPageContainer;
